import type { SVGProps } from 'react';

export function BowIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 14a1.7 1.7 0 0 0-1.207.5l-2.646 2.646A.5.5 0 0 0 3.5 18H5a1 1 0 0 1 1 1v1.5a.5.5 0 0 0 .854.354L9.5 18.207A1.7 1.7 0 0 0 10 17v-2a1 1 0 0 0-1-1z" />
      <path d="M18.12 10.191a1 1 0 0 1 1.346.436 14 14 0 0 1 1.128 9.718 2.17 2.17 0 0 1-2.565 1.608 2.17 2.17 0 0 1-1.027-.54l-3.71-3.706a1 1 0 0 1 1.415-1.414l3.673 3.67q.031.026.071.035a.17.17 0 0 0 .2-.126l.001-.002c.69-2.803.347-5.762-.968-8.333a1 1 0 0 1 .436-1.346M9 15H6.998a.7.7 0 0 0-.496.206l-.002.001L4.708 17H5a2 2 0 0 1 2 2v.293l1.794-1.794A.7.7 0 0 0 9 17.002zM3.652 3.408a14 14 0 0 1 9.724 1.132 1 1 0 0 1-.911 1.78 12 12 0 0 0-8.336-.97l-.001.002a.17.17 0 0 0-.122.114.17.17 0 0 0 .028.154l3.673 3.673a1 1 0 1 1-1.414 1.414l-3.71-3.71-.043-.046a2.17 2.17 0 0 1 1.112-3.543M22 7a1 1 0 1 1-2 0V5.414l-9.07 9.07c.044.167.07.34.07.516v1.998a2.7 2.7 0 0 1-.794 1.915v.001L7.562 21.56A1.5 1.5 0 0 1 5 20.498V19H3.5a1.5 1.5 0 0 1-1.47-1.794l.025-.108c.07-.25.202-.476.386-.66l2.645-2.645A2.7 2.7 0 0 1 7 13h2q.265.001.515.07L18.585 4H17a1 1 0 0 1 0-2h4a1 1 0 0 1 1 1z" />
    </svg>
  );
}
